<template>
  <div class="account-wrapper">
    <account-info />
  </div>
</template>
<script>
import { freshdeskMixin } from '@/mixins/Freshdesk'
import AccountInfo from '@/components/account/AccountInfo'

export default {
  data() {
    return {
      currentAccountTab: 'info'
    }
  },
  components: { AccountInfo },
  mixins: [freshdeskMixin],
  computed: {
    accountTabs() {
      const tabs = [
        {
          text: this.$t('account.index.accountInfoTab'),
          value: 'info'
        },
        {
          text: this.$t('account.index.currencySettingsTab'),
          value: 'currency-settings'
        }
      ]
      return tabs
    },
    isIndia() {
      return this.$store.state.account.country === 'India'
    }
  },
  mounted() {
    this.$mpTrack('Account page mounted')
    const currentPath = this.$route.path
    const currentTab = currentPath.split('/')[2]
    if (!this.isIndia && currentTab === 'currency-settings') {
      // TODO - Refactore this logic in router.js file
      this.$router.push({ path: 'info' })
      return
    }
    this.currentAccountTab = currentTab
  },
  methods: {
    onTabChange(tab) {
      this.$mpTrack(`Account Page - tab change to ${tab}`)
      this.currentAccountTab = tab
      this.$router.push({ path: tab })
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/palette';

.account-wrapper {
  .heading {
    font-size: 3rem;
    font-weight: bold;
    color: map-get($noble-blue, 500);
  }
  .account-tabs {
    label {
      &:hover {
        color: map-get($wealthy-green, 500);
      }
      background-color: white;
    }
    .btn-outline-primary {
      background: $noble-blue-100;
      color: $noble-blue-500;
      border-width: 1px;
      border-style: solid;
      border-color: $sky-blue-400 !important;
      border-radius: 8px 8px 0px 0px;
      border-top-right-radius: 8px !important;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      padding-left: 40px;
      padding-right: 40px;
      margin-right: 8px;
      &.active {
        background: $white;
        color: $noble-blue-500;
        border-bottom: 0px !important;
        margin-right: 8px;
        font-weight: 700;
      }
      &:focus {
        box-shadow: none !important;
      }
      &:active {
        color: $white;
        background-color: $sky-blue-400;
        border-color: $sky-blue-400;
      }
      &:hover {
        color: $white;
        background-color: $sky-blue-400;
        border-color: $sky-blue-400;
        box-shadow: none !important;
      }
    }
  }
  .tab-body {
    margin-top: 3rem;
  }
}
</style>
